<template>
    <el-dialog custom-class="inner-dialog-class"  width="500px" title="余额调整" :visible.sync="dialogVisible"  @close="closeEditBalance" :close-on-click-modal="false" :show-close="false" append-to-body>
        <el-form :model="editBalanceForm" :rules="rules1" ref="formIn" size="mini" label-width="100px">
            <el-form-item label="当前余额:" >
                <span class="cprimary">{{editBalance.money}}元</span>                            
            </el-form-item> 
            <el-form-item label="余额增减:" >
                <el-radio-group v-model="editBalanceForm.balanceType">
                    <el-radio :label="item.value" v-for="(item,index) in editBalanceForm.balanceTypeList" :key="index">{{item.label}}</el-radio>
                </el-radio-group>
            </el-form-item> 
            <el-form-item label="修改数额:" prop="balance">
                <el-input v-model="editBalanceForm.balance" type="text" placeholder="请输入" size="mini" class="dialog-div-input"><template slot="append">元</template></el-input>
            </el-form-item>  
            <el-form-item label="备注信息:" prop="note">
                <el-input v-model="editBalanceForm.note" :rows="3" type="textarea" placeholder="请输入备注信息（可选）"></el-input>
            </el-form-item>  
            <el-form-item label="修改后余额:" >
                <span class="cprimary">{{getNowBalance}}元</span>                            
            </el-form-item> 
        </el-form>   
        <div slot="footer" class="dialog-footer">
            <el-button size="mini" @click="closeEditBalance">取 消</el-button>
            <el-button class="dialog-btn" type="primary" size="mini" @click="editBalanceSure" :disabled="loading">确 定</el-button>
        </div>                           
    </el-dialog>
</template>
<script>
export default {
    name: 'BalanceAction',
    props:{
        dialogVisible:{
            type: Boolean,
            default: false,
        },
        editBalance:{
            type: Object,
            default: function () {
                return {}
            }
        },
        loading:{
            type:Boolean,
            default:false,
        }
        
    },
    data() {
        
        const validateBalance = (rule, val, callback) => {
            if(val.length > 9){
                callback(new Error('最多支持 9 位数字输入，请重试'));
            }else if (!/^\d{0,9}$/.test(val)){
                callback(new Error('最多支持 9 位数字输入，请重试'));
            }else{
                callback();
            }

            
        };
        return {
            
            rules1:{
                    balance:[
                        { required: true, message: '修改数额不能为空', trigger: 'blur' },
                        { validator :validateBalance,trigger:'blur'}
                    ]
                },
            editBalanceForm: {
                visible:false,
                balanceTypeList:[ //余额增减类型
                    {label:'余额增加',value:'IN'},
                    {label:'余额减少',value:'OUT'},
                ],
                balanceType:'IN',//余额增减类型选项值
                balance:'',//修改数额
                nowBalance:'',//修改后余额
                note:'',//备注信息
            },
        }
    },
    
    computed: {
            getNowBalance(){
                let balance = this.editBalance.money
                if(!this.editBalanceForm.balance){
                    balance = this.editBalance.money
                }else{
                    if(this.editBalanceForm.balanceType == 'IN'){
                        
                        balance = Number(this.editBalance.money) + Number(this.editBalanceForm.balance)
                    }else{
                        balance = Number(this.editBalance.money) - Number(this.editBalanceForm.balance)
                    }
                   
                }
                this.editBalanceForm.nowBalance = balance;
               return  balance
            }
        },
    methods:{
        closeEditBalance(){
                       
            this.resetForm('formIn')
            this.$emit('closeEditBalance')
        },
         //重置表单
         resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        editBalanceSure(){
            this.$refs['formIn'].validate((valid) => {
                    if (valid){
                        let data = {
                            ...this.editBalance,
                            ...this.editBalanceForm
                        }
                        this.$emit('editBalanceSure',data)
                    }else{
                        return false;
                    }
                })
        }
    }
}
</script>
<style lang="scss" scoped>
    
    .dialog-div-input{
        width: 200px;
    }
</style>
